import logo from './logo.svg';
import './App.css';
import TodoHandle from './Components/TodoHandle';

function App() {
  return (
    <div className="App">
      <TodoHandle/>
    </div>
  );
}

export default App;
